import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DialogZipcodeComponent } from './dialog-zipcode.component';

import { AppSheetContractorComponent } from '../chrome/app-sheet-contractor.component';

import {
  AuthenticationService,
  ContactApiService,
  ContractorServiceZipApiService,
  CrossSiteNavigationService
} from '../data-services/index';

import {
  IContact, IUser, IHelp, HelpApiService, IContactInput,
  IContractorServiceZip, IContractorServiceZipInput, UtilityService, AppLoadService, ContractorApiService,
  ZipCodeApiService,
  IZipCode,
  
  IGroupByCountyOutput
} from '@ebb-v2/ebb-integration';
import { DialogDeleteZipcodeComponent } from './dialog-deletezipcode.component';
import { DialogPortalContractorReviewsComponent } from '../grant/dialog/dialog-contractorreviews.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { cloneDeep } from '@apollo/client/utilities';
import { LoadingService } from '../spinner/loading.service';


@Component({
  selector: 'ebb-portal-directory',
  templateUrl: './directory.component.html'
})

export class DirectoryComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public currentContractorServiceZip: IContractorServiceZip[];
  public listHelp: IHelp[] = [];

  public formIncludeInDirectory: FormGroup;


  public textContractorDirectoryFemaComplete: string;
  public textContractorDirectoryFemaIncomplete: string;

  public businessLogo: string;
  public businessLogoRoot: string;
  public genericLogo: string;
  public showMore = false;

  public ebbTrainingUrl: string;
  public essTrainingUrl: string;
  public listZip: IZipCode[] = [];
  public addlistZip: IZipCode[] = [];
  public listZip25miles: IZipCode[] = [];
  public currentContractorServiceZipcodes: IZipCode[] = [];
  displayedColumns: string[] = ['county', 'zipCodes'];
  isLoading = false;
 public currentzipcodesgroupbycounty : IGroupByCountyOutput[] =[];
  constructor(
    private readonly apiAppSettings: AppLoadService,
    private readonly authenticationService: AuthenticationService,
    private readonly xSiteNavigationService: CrossSiteNavigationService,
    private readonly apiContact: ContactApiService,
    private readonly apiContractorServiceZip: ContractorServiceZipApiService,
    private readonly apiHelp: HelpApiService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly infoSheet: MatBottomSheet,
    private readonly dialogProxy: MatDialog,
    private readonly diadeletelogProxy: MatDialog,
    public readonly util: UtilityService,
    private readonly dialogContractorReviews: MatDialog,
    private apiContractor: ContractorApiService,
    public readonly apiZipCode: ZipCodeApiService,
    private loadingService: LoadingService
  ) {
    const envSettings = this.apiAppSettings.readEnvironSettings();

    this.genericLogo = `${envSettings.uriEbbAssets}/images/ContractorLogo.png`;
    this.businessLogoRoot = `${envSettings.uriApiRoot}/files/contractorLogo/`;
  }

  async ngOnInit() {
    await this.loadData();
    this.currentUser = this.authenticationService.currentUserValue;
    this.initializeForms();
   this.getContact(this.currentUser.id);
  
    
    this.loadHelpText();

    this.ebbTrainingUrl = this.xSiteNavigationService.ebbSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
    this.essTrainingUrl = this.xSiteNavigationService.essSiteUrl(
      '/Contractors-Design-Professionals/FEMA-Education-Course', this.currentUser
    );
  }

  private async loadData(): Promise<void> {
    try {
      const _data = await this.apiZipCode.getDetailed().toPromise();
      var data = cloneDeep(_data);
      this.listZip = this.sortZipCodesByZip(data);
    } catch (error) {
      console.warn(`${JSON.stringify(error)}`);
    }
  }
  // private loadData(): void {
  //   this.apiZipCode
  //   .getDetailed()
  //   .subscribe(
  //     _data => {
  //       var data = cloneDeep(_data);
  //       this.listZip =this.sortZipCodesByZip(data);

   
        
  //     },
  //     error => console.warn(`${JSON.stringify(error)}`),
  //   );
  // }
  private sortZipCodesByZip(zipCodes: IZipCode[]): IZipCode[] {
    const length = zipCodes.length;
    for (let i = 0; i < length - 1; i++) {
      for (let j = 0; j < length - i - 1; j++) {
        if (zipCodes[j].name > zipCodes[j + 1].name) {
          // Swap zipCodes[j] and zipCodes[j + 1]
          const temp = zipCodes[j];
          zipCodes[j] = zipCodes[j + 1];
          zipCodes[j + 1] = temp;
        }
      }
    }
    return zipCodes;
  }
  getLatLong(zipCode: string,list :IZipCode[]): { lat: number, lng: number } {
    const zipLocation = list.find(z => z.name === zipCode);
    if (zipLocation) {
      return { lat: parseFloat(zipLocation.latitude), lng: parseFloat(zipLocation.longitude) };
    }
    return null;
  }
  getZipCodesWithinRadius(zipCode: string, radius: number = 25, list :IZipCode[]): IZipCode[] {
    const centerLocation = this.getLatLong(zipCode,list);
    if (!centerLocation) return [];

    const radiusInKm = radius * 1.60934; // Convert miles to kilometers

    return list.filter(location => {
      const distance = this.haversineDistance(centerLocation.lat, centerLocation.lng, parseFloat(location.latitude), parseFloat(location.longitude));
      return distance <= radiusInKm;
    }).map(location => location);
  }
  private haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const toRad = (x: number) => x * Math.PI / 180;
    const R = 6371; // Earth radius in km

    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in km
  }
  public onShowReviews(event) : void {
    event.preventDefault();
    this.apiContractor
      .getContractorReviews(this.currentUser.id)
      .subscribe(
        data => {
         this.dialogContractorReviews.open(DialogPortalContractorReviewsComponent, {
            width: '600px',
            height: '600px',
            data: {
              reviews: data,
              name: this.currentContact.businessName,
              licenseNo: this.currentContact.contractorLicenseNumber,
              previewLimit: 3,
              contractor:true,
              
            }
          });
        },
        error => console.warn(error),
      );
  }
  private initializeForms(): void {
    
     this.formIncludeInDirectory = this.fb.group({
    withdrawFromEbbDirectory: [false],
    withdrawFromEssDirectory: [false],
    withdrawFromEmrDirectory: [false],
  });
  }

  private getContact(currentId: string): void {
    this.apiContact.getContact(currentId,true).subscribe(
      data => {
        this.currentContact = cloneDeep(data);
        this.currentContact.id
          ? (this.businessLogo = `${this.businessLogoRoot}${
              this.currentUser.id
            }`)
          : (this.businessLogo = this.genericLogo);
       this.PatchForm();
              this.getContactorServiceZip(this.currentUser.id);
      },
      error =>
        console.warn(`ERROR: ContractorDirectory.getContact() - ${error}`)
    );
  }

private PatchForm(): void {
  const ebbIn = !!this.currentContact?.contractorInDirectory;
  const essIn = !!this.currentContact?.essContractorInDirectory;
  const emrIn = !!this.currentContact?.emrContractorInDirectory;

  this.formIncludeInDirectory?.patchValue({ withdrawFromEbbDirectory: !ebbIn });
  this.formIncludeInDirectory?.patchValue({ withdrawFromEssDirectory: !essIn });
  this.formIncludeInDirectory?.patchValue({ withdrawFromEmrDirectory: !emrIn });
}

  public getContractorImageError(event) {
    event.target.src = this.genericLogo;
  }

  private getContactorServiceZip(currentId: string): void {
    this.apiContractorServiceZip.get(currentId).subscribe(
      _data => {
        let data = cloneDeep(_data);
        this.currentContractorServiceZip = data.sort((a, b) =>
          a.zipCode > b.zipCode ? 1 : -1
        );
        const zipCodeNames = new Set(this.currentContractorServiceZip.map(contractor => contractor.zipCode));
    
        this.currentContractorServiceZipcodes  = this.listZip.filter(zipCode => zipCodeNames.has(zipCode.name));
        this.addlistZip  = this.listZip.filter(zipCode => !zipCodeNames.has(zipCode.name));
        this.listZip25miles = this.getZipCodesWithinRadius(this.currentContact.address2_PostalCode, 25,this.addlistZip );
        const groupedByCounty = this.currentContractorServiceZipcodes.reduce((acc, zipCode) => {
          if (!acc[zipCode.county]) {
              acc[zipCode.county] = [];
          }
          acc[zipCode.county].push(zipCode.name);
          return acc;
      }, {} as { [key: string]: string[] });
      
      this.currentzipcodesgroupbycounty = Object.keys(groupedByCounty).map(county => ({
          county,
          zipCodes: groupedByCounty[county].join(', ')
      }));
      this.currentzipcodesgroupbycounty = this.currentzipcodesgroupbycounty.sort((a, b) =>
        a.county > b.county ? 1 : -1
      );
      },
      error =>
        console.warn(
          `ERROR: ContractorDirectory.getContactorServiceZip() - ${error}`
        )
    );
  }

  private loadHelpText(): void {
    this.apiHelp.getList().subscribe(
      _data => {
        let data = cloneDeep(_data);
        this.listHelp = [...data];
        const indexContractorDirectoryFemaComplete = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractordirectoryfemacomplete'
        );
        if (indexContractorDirectoryFemaComplete >= 0)
          this.textContractorDirectoryFemaComplete = this.listHelp[
            indexContractorDirectoryFemaComplete
          ].answer;

        const indexContractorDirectoryFemaIncomplete = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractordirectoryfemaincomplete'
        );
        if (indexContractorDirectoryFemaIncomplete >= 0)
          this.textContractorDirectoryFemaIncomplete = this.listHelp[
            indexContractorDirectoryFemaIncomplete
          ].answer;
      },
      error => console.log(error)
    );
  }

  public onChangeIncludeInDirectory(event, directoryType: string): void {
    const excludeFromDirectory = event?.checked === true;
    const inputListing: IContactInput = {} as IContactInput;
    switch (directoryType) {
      case 'EBB':
        inputListing.contractorInDirectory = !excludeFromDirectory;
        break;
      case 'ESS':
        inputListing.essContractorInDirectory = !excludeFromDirectory;
        break;
      case 'EMR':
        inputListing.emrContractorInDirectory = !excludeFromDirectory;
        break;
    }
    
    this.apiContact.updateContact(inputListing).subscribe(
      _data => {
         this.currentContact = cloneDeep(_data);
         this.PatchForm();
      },
      error =>
        console.warn(
          `ERROR: Directory.onChangeIncludeDirectory ${JSON.stringify(error)}`
        )
    );
  }

  public showContractorDirectory(programTypes: string): void {
    this.infoSheet.open(AppSheetContractorComponent, {
      data: {
        isPortal: false, //contractor view of public search, so false
        programTypes: programTypes
      }
    });
  }

  public onToggleMoreContractor(event): void {
    event.preventDefault();
  this.showMore = !this.showMore;
  }

  public formatLink(value: string) {
    if (value) {
      value = value.toLowerCase();
      if (value.startsWith('http')) {
        return value;
      } else {
        return `http://${value}`;
      }
    }
    return '';
  }

  public addServiceZipCode(): void {
    const dialogRef = this.dialogProxy.open(DialogZipcodeComponent, {
      width: '90vw',
      maxWidth: '500px',
      data: { addlistZip:this.addlistZip,listZip25miles:this.listZip25miles}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        
        const contractorServiceZips: IContractorServiceZipInput [] = [];
        result.forEach(i => {

          if (
            this.currentContractorServiceZip.findIndex(l => l.name === i.name) <
            0
          ) {
            const contractorServiceZip: IContractorServiceZipInput = {} as IContractorServiceZipInput;

            contractorServiceZip._Ebb_ContactId = this.currentUser.id;
            contractorServiceZip.name = i.name;
            contractorServiceZip.zipCode = i.name;
            const zipLocation = this.listZip.find(z => z.name === i.name);
            if(zipLocation != null){
              contractorServiceZip._Ebb_ZipCodeId =zipLocation.id;
            }
            contractorServiceZips.push(contractorServiceZip);
          }

   
        });
         this.isLoading = true;
        if(contractorServiceZips.length>0){
          this.loadingService.show();
          this.apiContractorServiceZip
          .batchsave(contractorServiceZips)
          .subscribe(
            data => {
              
             this.getContactorServiceZip(this.currentUser.id)
              this.isLoading = false;
              this.loadingService.hide();
            }
            ,
            error =>{
              console.warn(
                `ERROR: Add new service ZIP ${JSON.stringify(error)}`
                
              );
              this.isLoading = false;
              this.loadingService.hide();}
          );}
      }
    });
  }
  public deleteServiceZipCode(): void {
    const dialogDeleteRef = this.diadeletelogProxy.open(
      DialogDeleteZipcodeComponent,
      {
        width: '90vw',
        maxWidth: '500px',
        data: this.currentContractorServiceZip
      }
    );

    dialogDeleteRef.afterClosed().subscribe(result => {
      if (result) {
        const contractorServiceZips: IContractorServiceZipInput [] = [];
        result.forEach(i => {
          const records = this.currentContractorServiceZip.filter(
            l => l.name === i.name
          );
          if (records.length > 0) {
            const isexists =contractorServiceZips.filter(
              l => l.name === records[0].name
            ).length>0?true:false;
            if(!isexists)
            records.forEach(record => {
            
              const contractorServiceZip: IContractorServiceZipInput = {} as IContractorServiceZipInput;
              contractorServiceZip.id = record.id;
              contractorServiceZip._Ebb_ContactId = record._Ebb_ContactId;
              contractorServiceZip.name = record.name;
              contractorServiceZip.zipCode = record.zipCode;
              contractorServiceZips.push(contractorServiceZip);
            });
           
        
          }
        });
        this.isLoading = true;
        if(contractorServiceZips.length>0){
          this.loadingService.show();
        this.apiContractorServiceZip
        .batchdelete(contractorServiceZips)
        .subscribe(
          data => {
            
            this.getContactorServiceZip(this.currentUser.id)
            this.isLoading = false;
            this.loadingService.hide();
          },
          error =>{
            console.warn(
              `ERROR: Remove service ZIP ${JSON.stringify(error)}`
            );
            this.isLoading = false;
            this.loadingService.hide();
          }
        );
      }}
    });
  }
  public navigateToAccount(): void {
    this.router.navigate([`/account`]);
  }
  public redirectToESSTraining() {
    this.router.navigate(['/trainingess']);
  }
  public  redirectToEBBTraining() {
    this.router.navigate(['/trainingebb']);
  }
  public redirectToEMRTraining() {
    this.router.navigate(['/trainingemr']);
  }
}
